import { useCallback } from "react";
import { InfoHeaderDataType } from "../../interfaces/InfoHeaderType";
import useHintStore from "../../store/hintStateStore";
import { generateStyleClasses } from "../../helpers/commonFunctions";

const InfoHeader = ({ data }: { data: InfoHeaderDataType }) => {
  const { setOpen } = useHintStore();
  const { style, textColor: color, spacing, hint, text } = data;

  const openModal = () => {
    if (hint && hint.type && hint.type.toLocaleLowerCase() === "redirect") {
      window.open(hint.link, "_blank");
      return;
    }
    setOpen(true, hint?.link);
  };

  const textSplitter = useCallback(
    (text: string) => {
      if (!text) return null;
      let textSplit = text?.split("\n");
      return (
        <>
          {textSplit.map((item: string, idx: number) => {
            return (
              <p
                className={`vas-m-0 ${style?.bold ? "vas-fw-bold" : ""} ${
                  style?.size === "xlarge"
                    ? "vas-fs-4"
                    : style?.size === "big"
                    ? "vas-fs-5"
                    : "vas-fs-6"
                } ${spacing ? "vas-mt-4" : ""}`}
                key={idx}
                style={{ color }}
              >
                {item}
              </p>
            );
          })}
        </>
      );
    },
    [data?.style, data?.textColor]
  );

  return (
    <div className="vas-card vas-w-100" style={{ border: "0px" }}>
      <div className="vas-w-100 vas-d-flex vas-flex-column vas-align-items-start">
        {textSplitter(text)}
      </div>
      {hint && (
        <p className={`vas-mt-3 vas-mb-0 vas-fs-6 ${generateStyleClasses(hint.style)}`}>
          <span
            className="pointerCursor"
            style={{ color: hint?.textColor }}
            onClick={openModal}
          >
            {hint?.text}
          </span>
        </p>
      )}
    </div>
  );
};

export default InfoHeader;
